var byProxy = false;
var mainDomain;
var testDomain;
var test3Domain;

/* 本地开发走proxy */
if (/\d+\.\d+\.\d+\.\d+/.test(location.host)) {
    byProxy = true;
    // loginUrl = "//login.focus-dev.cn/login";
}

/* 测试线上等环境 */
if (!byProxy) {
    var hostArr = location.hostname.split('.');
    // 旧项目测试环境 .focustest  新项目.focus-dev||.focus-test等
    mainDomain = '.' + hostArr[ hostArr.length - 2 ] + '.' + hostArr[ hostArr.length - 1 ];
    testDomain = mainDomain == '.focus.cn' ? mainDomain : '.focus-test.cn'
    test3Domain = mainDomain == '.focus.cn' ? mainDomain : '.focus-test3.cn'
}

module.exports = {
    domain: '',
    'loginDomain': byProxy ? '//login.focus-test.cn' : `//login${testDomain}`,
    'loginOriginDomain': byProxy ? '//login.focus-test.cn' : `//login${mainDomain}`,
    'ajaxDomain': byProxy ? '//login.focus-test.cn' : '//login.focus.cn',
    'bbsDomain': byProxy ? '//bbs.focus-test.cn' : '//bbs.focus.cn',
    'userTestDomain': byProxy ? '//u.focus-test.cn' : `//u${mainDomain}`,
    'userDomain': byProxy ? '//u.focus-test.cn' : '//u.focus.cn',
    'houseDomain': byProxy ? '//house.focus-dev.cn' : `//house${mainDomain}`,
    'homeDomain': byProxy ? '//home.focus.cn' : `//home${mainDomain}`,
    'homeOnlineDomain': byProxy ? '//home.focus.cn' : `//home.focus.cn`,
    'adDomain': byProxy ? '//adv-sv-show.focus-test.cn' : `//adv-sv-show${mainDomain}`,
    'mpDomain': byProxy ? '//mp-sv-extend.focus-test1.cn' : `//mp-sv-extend${mainDomain}`,
    'esfDomain': byProxy ? '//esf.focus-test.cn' : `//esf${mainDomain}`,
    'homeHostName': byProxy ? 'home.focus.cn' : `home${mainDomain}`

}



// WEBPACK FOOTER //
// ./src/config.js